"use client";

import { useTranslations } from "next-intl";
import NextLink from "next/link";
import React, { useEffect, useRef } from "react";
import { cn } from "../../../../helpers/classNames";
import { getRoute } from "../../../../helpers/urls/getRoute";
import { useCountry, usePageParams } from "../../../ApplicationState/hooks";
import { sendError } from "../../../ErrorBoundary/helpers";
import { ItemInner } from "./itemInner";
import styles from "./styles.module.scss";

type Props = {
    location: {
        code: string;
        name: string;
        seoString: string;
    };
};

export const Item: React.FC<Props> = ({ location }) => {
    const pageParams = usePageParams();
    const t = useTranslations("component.topLocations");
    const country = useCountry();
    const ref = useRef<HTMLDivElement>(null);
    const isActive = pageParams.code === location.code;

    useEffect(() => {
        if (isActive && ref.current) {
            ref.current.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        }
    }, [isActive]);

    try {
        const href = getRoute({
            parameters: {
                pageName: "forecastToday",
                code: location.code,
                seoString: location.seoString,
            },
            country,
        });

        return (
            <div className={styles.item} ref={ref}>
                <NextLink
                    href={href}
                    title={t("linkTitle", {
                        locationName: location.name,
                    })}
                    className={cn(styles.link, isActive && styles.active)}
                    onNavigate={(e) => {
                        if (isActive) {
                            e.preventDefault();
                        }
                    }}
                >
                    <ItemInner label={location.name} />
                </NextLink>
            </div>
        );
    } catch (e) {
        sendError(e);
        return null;
    }
};
